export const alertConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR'
};



// WEBPACK FOOTER //
// ./src/redux/constant/alert-constant.jsx